import { Component, OnInit, inject } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { InviaMassivoResponse } from '../../model/iscritti-data';

@Component({
  selector: 'app-dialog-avvisi',
  templateUrl: './dialog-avvisi.component.html',
  styleUrl: './dialog-avvisi.component.scss'
})
export class DialogAvvisiComponent implements OnInit {
  private dialog_config = inject(DynamicDialogConfig);

  data?: InviaMassivoResponse;

  ngOnInit(): void {
    this.data = this.dialog_config.data;
  }

}
